/* eslint-disable radix */
/* eslint-disable react/jsx-fragments */
import React, { useState } from 'react';
import WorkshopRegForm from '../../Pages/Workshop/RegistrationForm';
import Icon from '../Icon';
import ImageBlurFallback from '../ImageBlurFallback';
import ABOUT_WORKSHOP from '../../Assets/v2/workshop/aboutWorkshop.png';
import Modal from '../Modal';
import './styles.css';
import { connect } from 'react-redux';

const WorkshopCard = ({
  seminar,
  buttonText = 'Register Now',
  registrationStatus = {},
  registerModalProps = {},
  viewDetailModalProps = {},
  isInternship = false
}) => {
  const {
    courseCardImageUrl = '',
    venue = '',
    name = '',
    description,
    studentSeats,
    startDate = '',
    endDate = '',
    fees = '',
    syllabus,
    seminar_id,
    timeDetails
  } = seminar;
  const [
    registrationModalVisibility,
    setRegistrationModalVisibility
  ] = useState(false);

  const [detailsModalVisibility, setDetailsModalVisibility] = useState(false);

  const splitDate = date => date.trim().split('-');

  const startingDate = new Date(
    `${splitDate(startDate)[1]}/${splitDate(startDate)[2]}/${
      splitDate(startDate)[0]
    }`
  );
  const startAtMonth = startingDate.toLocaleString('default', {
    month: 'long'
  });
  const startAtYear = startingDate.getFullYear();

  const endingDate = new Date(
    `${splitDate(endDate)[1]}/${splitDate(endDate)[2]}/${splitDate(endDate)[0]}`
  );
  const endAtMonth = endingDate.toLocaleString('default', { month: 'long' });
  const endAtYear = endingDate.getFullYear();

  const getDateWithTh = date => {
    if (date > 3 && date < 21)
      return (
        <React.Fragment>
          {date}
          <sup>th</sup>
        </React.Fragment>
      );
    switch (date % 10) {
      case 1:
        return (
          <React.Fragment>
            {date}
            <sup>st</sup>
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            {date}
            <sup>nd</sup>
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            {date}
            <sup>rd</sup>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            {date}
            <sup>th</sup>
          </React.Fragment>
        );
    }
  };

  const startAtDate = getDateWithTh(startingDate.getDate());
  const endAtDate = getDateWithTh(endingDate.getDate());

  const seminarDateString =
    parseInt(startAtYear, 10) !== parseInt(endAtYear, 10) ? (
      <React.Fragment>
        {startAtDate}&nbsp;{startAtMonth}&nbsp;{startAtYear}&nbsp;to&nbsp;
        {endAtDate}&nbsp;{endAtMonth}, {endAtYear}
      </React.Fragment>
    ) : parseInt(startAtDate, 10) === parseInt(endAtDate, 10) ||
      parseInt(startAtDate, 10) > parseInt(endAtDate, 10) ? (
      <React.Fragment>
        {startAtDate}&nbsp;{startAtMonth},&nbsp;{startAtYear}
      </React.Fragment>
    ) : (
      <React.Fragment>
        {startAtDate}&nbsp;to&nbsp;{endAtDate}&nbsp;{startAtMonth},&nbsp;
        {startAtYear}
      </React.Fragment>
    );

  const toggleRegistrationVisibility = () => {
    setRegistrationModalVisibility(prevVisibility => !prevVisibility);
  };

  const toggleDetailsVisibility = () => {
    setDetailsModalVisibility(prevVisibility => !prevVisibility);
  };
  return (
    <div className="course_card_iitd_parent_container">
      <div className="course_card_iitd">
        <div className="course_card_iitd_image">
          <ImageBlurFallback
            src={courseCardImageUrl ? `${courseCardImageUrl}` : ''}
            alt="seminar image"
            className="course-card-image"
          />
        </div>
        <div className="course_card_iitd_description_section">
          {!!name && <h1 className="course_card_iitd_heading">{name}</h1>}
          {/* {!!venue && <p className="course_card_iitd_text">{venue}</p>} */}
          {!!seminarDateString && !isInternship && (
            <div className="icon-details">
              <Icon
                style={{ color: seminar.colorCode || '#1B5180' }}
                className="fas fa-calendar-check fa-lg"
              />
              <p className="course_card_iitd_text">{seminarDateString}</p>
            </div>
          )}
          {!!timeDetails && !isInternship && (
            <div className="icon-details">
              <Icon
                style={{ color: seminar.colorCode || '#1B5180' }}
                className="fas fa-clock fa-lg"
              />
              <p className="course_card_iitd_text">{timeDetails}</p>
            </div>
          )}
          {!!fees && !isInternship && (
            <div className="icon-details">
              <Icon
                style={{ color: seminar.colorCode || '#1B5180' }}
                className="fas fa-tags fa-lg"
              />

              <p className="course_card_iitd_text price">
                INR {fees / 100} Only
              </p>
            </div>
          )}

          {isInternship && (
            <React.Fragment>
              <div className="icon-details">
                <Icon
                  style={{ color: seminar.colorCode || '#1B5180' }}
                  className="fas fa-clock fa-lg"
                />

                <p className="course_card_iitd_text price">4 Weeks Program</p>
              </div>
              <div className="icon-details">
                <Icon
                  style={{
                    color: seminar.colorCode || '#1B5180'
                  }}
                  className="fas fa-clock fa-lg"
                />

                <p className="course_card_iitd_text price">6 Weeks Program</p>
              </div>
            </React.Fragment>
          )}
          {/* {!!description && (
            <p className="course_card_iitd_text">{description}</p>
          )} */}
        </div>

        <div className="course_card_register_container">
          {(!!description || syllabus.length > 0) && (
            <button
              onClick={toggleDetailsVisibility}
              style={{ color: seminar.colorCode || '#1B5180' }}
              className="course_details_button">
              <Icon className="fas fa-eye iconClass" />
              View Details
            </button>
          )}
          {/* 
          {!!studentSeats && (
            <p className="course_card_iitd_text">Total Seats: {studentSeats}</p>
          )} */}
          <button
            onClick={toggleRegistrationVisibility}
            style={{ backgroundColor: seminar.colorCode || '#1B5180' }}
            className="register_now_course_card">
            {buttonText}
          </button>
        </div>

        <Modal
          slideIn={true}
          transparent={false}
          closeButtonStyle="close_btn_style"
          className="modal_container"
          toogleModal={toggleDetailsVisibility}
          active={detailsModalVisibility}>
          <React.Fragment>
            <h1 className="course_card_modal_heading">
              {viewDetailModalProps.heading || 'About the Workshop'}
            </h1>
            <div className="course_details_modal_container">
              <div className="course_card_modal_image_desc_container">
                <div className="course_modal_image_container">
                  <ImageBlurFallback
                    src={ABOUT_WORKSHOP}
                    alt="seminar image"
                    className="course_modal_image_container"
                  />
                </div>
                <div className="course_card_modal_description_section">
                  {!!name && (
                    <h1 className="course_card_modal_desc_heading">{name}</h1>
                  )}
                  {!!seminarDateString && !isInternship && (
                    <div className="icon-details modal-icon">
                      <Icon
                        style={{ color: '#084FC7' }}
                        className="fas fa-calendar-check fa-lg"
                      />
                      <p className="course_card_desc_modal_text">
                        {seminarDateString}
                      </p>
                    </div>
                  )}
                  {!!timeDetails && !isInternship && (
                    <div className="icon-details modal-icon">
                      <Icon
                        style={{ color: '#084FC7' }}
                        className="fas fa-clock fa-lg"
                      />
                      <p className="course_card_desc_modal_text">
                        {timeDetails}
                      </p>
                    </div>
                  )}
                  {!!fees && !isInternship && (
                    <div className="icon-details modal-icon">
                      <Icon
                        style={{ color: '#084FC7' }}
                        className="fas fa-tags fa-lg"
                      />

                      <p className="course_card_desc_modal_text price">
                        INR {fees / 100} Only
                      </p>
                    </div>
                  )}
                  {isInternship && (
                    <React.Fragment>
                      <div className="icon-details modal-icon">
                        <Icon
                          style={{ color: seminar.colorCode || '#1B5180' }}
                          className="fas fa-clock fa-lg"
                        />

                        <p className="course_card_iitd_text price">
                          4 Weeks Program
                        </p>
                      </div>
                      <div className="icon-details modal-icon">
                        <Icon
                          style={{
                            color: seminar.colorCode || '#1B5180'
                          }}
                          className="fas fa-clock fa-lg"
                        />

                        <p className="course_card_iitd_text price">
                          6 Weeks Program
                        </p>
                      </div>
                    </React.Fragment>
                  )}
                  {/* {!!description && (
            <p className="course_card_iitd_text">{description}</p>
          )} */}
                </div>
              </div>
              <div className="course_modal_sub_desc">
                {!!name && !isInternship && (
                  <h1 className="course_modal_sub_desc_heading">{name}</h1>
                )}
                {!!description && (
                  <p className="course_card_iitd_text course_modal_text">
                    {description}
                  </p>
                )}
                {!!seminarDateString && !isInternship && (
                  <p
                    className="course_card_iitd_text course_modal_text"
                    style={{ textAlign: 'initial' }}>
                    {seminarDateString}
                  </p>
                )}
              </div>
              <div className="course_modal_sub_syllabus">
                {!!syllabus && syllabus.length > 0 && (
                  <React.Fragment>
                    <p className="course_modal_sub_desc_heading">
                      {viewDetailModalProps.syllabusHeading ||
                        'Workshop Syllabus:'}
                    </p>
                    <ul className="course_syllabus_list">
                      {syllabus.map(item => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  </React.Fragment>
                )}
              </div>
            </div>
          </React.Fragment>
        </Modal>

        <Modal
          slideIn={true}
          style={registerModalProps.style}
          closeButtonStyle={registerModalProps.closeButtonStyle}
          transparent={registerModalProps.transparent || false}
          className={`modal_container_reg_form ${registrationStatus.success &&
            registrationStatus.failed &&
            'modal_container_reg_complete'}`}
          active={registrationModalVisibility}
          toogleModal={toggleRegistrationVisibility}>
          {!!registerModalProps.children ? (
            registerModalProps.children
          ) : (
            <WorkshopRegForm
              seminarId={seminar_id}
              fees={fees}
              toggleRegistrationVisibility={toggleRegistrationVisibility}
            />
          )}
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (store, props) => {
  return {
    registrationStatus: {
      start: store.seminarData.seminarRegistration.start,
      success: store.seminarData.seminarRegistration.success,
      failure: store.seminarData.seminarRegistration.failed
    }
  };
};
export default connect(
  mapStateToProps,
  null
)(WorkshopCard);



// WEBPACK FOOTER //
// ./src/Components/WorkshopCard/index.js